module.exports = __webpack_public_path__ + "static/media/mocktail.0946d57c.png";